import { render, staticRenderFns } from "./WXCW01RiZhi.vue?vue&type=template&id=2f0a5a52&"
import script from "./WXCW01RiZhi.vue?vue&type=script&lang=js&"
export * from "./WXCW01RiZhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports